export const agent = {
    yqmh: "Undang Kotak Misteri",
    yqzmh: "Undang dan Dapatkan Kotak Misteri",
    bfbkj: "100% Dapat Hadiah",
    yqpy: "Undang Teman",
    pywczcrw: "Teman mendaftar dan menyelesaikan tugas",
    hdcmhcs: "Dapatkan kesempatan membuka kotak misteri",
    jllb: "Daftar Hadiah",
    mhjlbk: "Hadiah kotak misteri mungkin termasuk: {text} Jumlah spesifik berdasarkan hadiah yang actually diterima!",
    kkcs: "Dapat dibuka {value} kali",
    mhmx: "Detail Kotak Misteri",
    jpmx: "Detail Hadiah",
    hdmhs: "Jumlah Kotak Misteri yang Diperoleh",
    hyjd: "Progress Teman",
    jplx: "Jenis Hadiah",
    dbmc: "Nama Token",
    ypf: "Telah Dikirim",
    wpf: "Belum Dikirim",
    lq: "Klaim",
    zblw: "Hadiah Sekitar",
    gxczmh: "Selamat Anda mendapatkan {amount}, undang teman baru, selesaikan tugas, dapatkan kotak misteri",
    lxkflq: "Silakan hubungi layanan pelanggan untuk mendapatkan hadiah merchandise",
    shdz: "Alamat Pengiriman",
    rwmc: "Nama Tugas",
    wczt: "Status Penyelesaian",
    hdmhsl: "Jumlah Kotak Misteri yang Diperoleh",
    zblqdz: "Alamat Pengambilan Merchandise",
    shr: "Penerima",
    dh: "Telepon",
    xxdz: "Alamat Lengkap",
    yqmhhdgz: "Aturan Aktivitas Undang Kotak Misteri",
    yqyl: "1. Apa itu Undang dan Dapat Hadiah Biking?",
    yhhkxt: "Undang dan Dapat Hadiah Biking adalah sistem reward pengguna Biking, bertujuan untuk memberi reward kepada semua pengguna setia yang mendukung Biking dan mengundang teman untuk bergabung dengan Biking.",
    yqhyhdfhjl: "Undang dan Dapat Hadiah Biking mudah digunakan, pengguna hanya perlu mengundang teman untuk mendapatkan hadiah yang melimpah.",
    cyhdhqjl: "2. Hadiah apa yang bisa didapatkan dengan berpartisipasi dalam aktivitas dan menyelesaikan tugas?",
    hywcrwhdjl: "Undang orang mengundang teman, teman menyelesaikan tugas yang sesuai, baik pengundang dan yang diundang dapat mendapatkan kotak misteri dan membukanya untuk mendapatkan hadiah.",
    mhhdgz: "3. Aturan Mendapatkan Kotak Misteri",
    syrwczc: "1. Yang diundang menyelesaikan pendaftaran dan verifikasi identitas——Yang diundang mendapatkan 1 kesempatan membuka",
    syrcz: "2. Yang diundang melakukan deposit ≥100USDT——Pengundang dan yang diundang masing-masing mendapatkan 1 kesempatan membuka",
    syrcssxf: "3. Yang diundang menghasilkan biaya kontrak ≥30USDT——Pengundang dan yang diundang masing-masing mendapatkan 2 kesempatan membuka",
    qqjyl: "4. Volume perdagangan opsi ≥200USDT——Pengundang dan yang diundang masing-masing mendapatkan 2 kesempatan membuka",
    yxjyl: "5. Volume perdagangan Gamefi ≥200USDT dan odds pesanan tidak kurang dari 1.2x, pesanan dengan odds di bawah 1.2x tidak dihitung——Pengundang dan yang diundang masing-masing mendapatkan 2 kesempatan membuka",
    xhmrjyl: "6. Volume pembelian spot ≥500USTD——Pengundang dan yang diundang masing-masing mendapatkan 1 kesempatan membuka",
    rwqbwc: "Setiap kali semua tugas undangan selesai, pengundang最多可以获得8个开启盲盒机会，yang diundang最多可以获得9个开启盲盒机会。Mengundang banyak orang, kesempatan mendapatkan kotak misteri bertambah secara kumulatif sesuai aturan.",
    qtsm: "4. Penjelasan Lainnya",
    mhffsj: "1. Waktu distribusi kotak misteri--Pemantauan latar belakang tugas diperbarui setiap 10 menit",
    jlffsj: "2. Waktu distribusi hadiah--Dikirim secara manual setiap hari jam 12 siang",
    syyhjkcj: "3. Semua pengguna dapat berpartisipasi, tidak bertentangan dengan aktivitas lainnya",
    mhcjs: "4. Kesempatan membuka kotak misteri direset pada tanggal 1 setiap bulan",
    yqmts: "Hanya mengundang pengguna menjadi bawahan, transaksi bawahan menghasilkan komisi biaya untuk Anda",
    fym: "Kode Komisi",
    fymts: "Undang dan berikan langsung kepada pengguna bawahan rasio komisi tidak lebih tinggi dari diri sendiri, transaksi bawahan akan dialokasikan komisi biaya sesuai rasio",
    szfym: "Atur Kode Komisi",
    xzfym: "Tambah Kode Komisi Baru",
    lj: "Tautan",
    fybl: "Rasio Komisi",
    yyqhys: "Jumlah Teman yang Diundang",
    sykcjs: "Sisa yang Dapat Dibuat",
    tjlx: "Jenis Rekomendasi",
    bwjs: "5. Jika ditemukan adanya individu atau tim yang mencoba memanipulasi福利 kotak misteri, BiKing berhak memotong dan membatalkan hak福利 akun. Semua pengguna yang berpartisipasi dalam福利 ini dianggap menerima syarat dan ketentuan福利 resmi, BiKing Exchange保留最终解释权。",
    swmr: "Jadikan Default",
    cffym: "Kode komisi duplikat, silakan masukkan kode komisi yang benar",
    qxtjfym: "Silakan tambahkan kode komisi terlebih dahulu",
    xywdbl: "10 <= Rasio komisi saya",
    qsrdybl: "Silakan masukkan rasio yang sesuai",
    qsrzqsl: "Silakan masukkan nilai yang benar",
    qsrbz: "Silakan masukkan catatan",
    bnbhzf: "Tidak boleh mengandung karakter khusus atau emoji",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/agent/ba.js